export const CONFIGURE = 'C';
export const SET_PRICE = 'S';
export const BID = 'B';
export const BUY_NOW = 'BN';
export const SELL_NOW = 'SN';

export const BID_PRICE = 'B';
